import React, { useState, useEffect } from 'react';
import { Container, IconButton, Box, Button, Modal, Card, Typography, TextField, Autocomplete } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ShareIcon from '@mui/icons-material/Share';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { ACTION_ICON_COLORS } from '../constants/iconActionColors';
import { useNavigate } from 'react-router-dom';
import * as endPoints from '../assets/js/endpoints';
import Loader from '../components/loader';
import DataTable from '../components/DataTable';
import PageTitle from '../components/PageTitle';
import { useConfirm } from '../assets/contexts/confirmContext';
import { useNotification } from '../assets/contexts/notificationContext';
import AddIcon from '@mui/icons-material/Add';
import { Helmet } from 'react-helmet';

const ManageClients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [shareOpen, setShareOpen] = useState(false);
  const [shareClientData, setShareClientData] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const navigate = useNavigate();
  const confirm = useConfirm();
  const { showNotification } = useNotification();

  const fetchClients = async () => {
    try {
      const data = await endPoints.getAllClients();
      setClients(Array.isArray(data) ? data : data.data);  

    } catch (_err) {
      showNotification('Error al obtener clientes', 'error');
    } finally {
      setLoading(false);
    }
  };

  const fetchEmployees = async () => {
    try {
      const data = await endPoints.getAllUsers();
      const emps = (Array.isArray(data) ? data : data.data).filter(u => (u.role || u.roles?.[0]?.name) === 'employee');
      setEmployees(emps);
    } catch (_err) {
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const handleDelete = async id => {
    const ok = await confirm('¿Eliminar cliente?');
    if (!ok) return;
    try {
      await endPoints.deleteClient(id);
      fetchClients();
      showNotification('Cliente eliminado', 'success');
    } catch (_err) {
      showNotification('Error eliminando cliente', 'error');
    }
  };

  const handleEdit = id => navigate(`/admin/createClient/${id}`);
  const openShare = client => {
    setShareClientData(client);
    setShareOpen(true);
    if (employees.length === 0) fetchEmployees();
  };

  const handleShare = async e => {
    e.preventDefault();
    if (!selectedEmployee) return;
    try {
      await endPoints.shareClient(shareClientData.id, selectedEmployee);
      showNotification('Cliente compartido', 'success');
      setShareOpen(false);
      setSelectedEmployee('');
      fetchClients();
    } catch (_err) {
      showNotification('Error compartiendo cliente', 'error');
    }
  };
  const handleCreate = () => navigate('/admin/createClient');

  if (loading) return <Loader />;

  const columns = [
    { id: 'name', label: 'Nombre' },
    { id: 'apellidos', label: 'Apellidos' },
    { id: 'email', label: 'Email' },
    { id: 'telefono', label: 'Teléfono' },
    { id: 'users', label: 'Empleados', sortable: false },
    { id: 'historial', label: 'Historial clínico', sortable: false },
  ];

  const rows = clients.map(c => ({
    ...c,
    users: c.users?.length > 0 ? c.users.map(u => u.name).join(', ') : 'Ninguno',
    historial: (
      <Button
        onClick={() => navigate(`/admin/clinicalHistory/${c.id}`)}
        startIcon={<VisibilityIcon />}
        sx={{ color: ACTION_ICON_COLORS.see }}
      >
        Ver historial
      </Button>
    ),
  }));

  const actions = client => (
    <>
      <IconButton onClick={() => handleEdit(client.id)} sx={{ color: ACTION_ICON_COLORS.edit }}>
        <EditIcon />
      </IconButton>
      <IconButton onClick={() => handleDelete(client.id)} sx={{ color: ACTION_ICON_COLORS.delete }}>
        <DeleteIcon />
      </IconButton>
      <IconButton onClick={() => openShare(client)} sx={{ color: ACTION_ICON_COLORS.share }}>
        <ShareIcon />
      </IconButton>
    </>
  );

 
      console.log('Clientes en estado:', clients);
      console.log('usuarios del empleado:', clients[8]?.users);

  return (
    <>
      <Helmet>
        <title>Gestión de Clientes | CES</title>
      </Helmet>
      <Container  sx={{ mt: 5, paddingBottom: 2, mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap:'wrap' }}>
          <PageTitle>Gestión de Clientes</PageTitle>
          <Button variant="contained" startIcon={<AddIcon />} onClick={handleCreate}>Crear Nuevo Cliente</Button>
        </Box>
        <DataTable columns={columns} rows={rows} actions={actions} />
        <Modal
          open={shareOpen}
          onClose={() => setShareOpen(false)}
          slotProps={{ backdrop: { onClick: () => setShareOpen(false) } }}
        >
          <Card onClick={e => e.stopPropagation()} sx={{ p:2, m:'5% auto', width:{ xs:'90%', sm:400 } }}>
            <Typography variant='h6' sx={{ textAlign:'center', p:2 }}>Compartir Cliente</Typography>
            <Box component='form' onSubmit={handleShare} sx={{ display:'flex', flexDirection:'column', gap:2 }}>
              <Autocomplete
                options={employees}
                value={employees.find(emp => String(emp.id) === String(selectedEmployee)) || null}
                onChange={(_event, newValue) => setSelectedEmployee(newValue ? newValue.id : '')}
                getOptionLabel={option => option.name}
                isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
                renderInput={params => (
                  <TextField {...params} label="Empleado" required />
                )}
              />
              <Box sx={{ display:'flex', gap:2, justifyContent:'center' }}>
                <Button onClick={() => setShareOpen(false)}>Cancelar</Button>
                <Button type='submit' variant='contained'>Compartir</Button>
              </Box>
            </Box>
          </Card>
        </Modal>
      </Container>
    </>
  );
};

export default ManageClients;
